import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { FieldFilter } from '@src/components/FieldFilter';
import { EntityType } from '@src/types';
import { SearchFilterBar, useLocale, useSessionState } from 'pe-core-frontend';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Fields } from '../Fields';
export const Metadata = () => {
    const { clientId, entityType } = useParams();
    const { t } = useLocale();
    const [filter, setFilter] = useSessionState(`fieldFilter_${entityType}`, {
        searchText: undefined,
        isActive: true,
    });
    const [searchText, setSearchText] = useState(filter?.searchText || '');
    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };
    const handleSearchChange = (searchValue) => {
        setSearchText(searchValue);
    };
    useEffect(() => {
        if (handleFilterChange) {
            handleFilterChange({
                ...filter,
                searchText,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);
    const isValid = Object.values(EntityType).includes(entityType);
    const basePath = `/admin/clients/${clientId}/metadata`;
    const headerNavItems = useMemo(() => {
        return [
            EntityType.EMPLOYEE,
            EntityType.PROGRAM,
            EntityType.PAYMENT_REQUEST,
            EntityType.PAYROLL_ITEM,
            EntityType.PAYROLL_PAYMENT,
        ].map(value => ({
            title: t(`metadata.entityType.${value}`),
            path: `${basePath}/${value}`,
            selected: entityType === value,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [basePath, entityType]);
    if (!entityType) {
        return _jsx(Navigate, { to: `/admin/clients/${clientId}/metadata/employee` });
    }
    if (!isValid) {
        return _jsx("div", { children: t('Invalid entity type') });
    }
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Metadata'), navLinks: headerNavItems, searchFilterActions: _jsx(SearchFilterBar, { enableSearch: true, enableFilter: true, filterActions: _jsx(FieldFilter, { filter: filter, onFilterChange: handleFilterChange }), isFilterActive: filter.isActive !== true, onSearchChange: handleSearchChange, searchText: filter?.searchText || '', searchPlaceholder: t('Search by Name or Code') }) }), _jsx(Fields, { clientId: Number(clientId), entityType: entityType, filter: filter })] }));
};
